import React from 'react';

import { styled } from './../styled';
import Select from '@material-ui/core/Select';
import FormLabel from '@material-ui/core/FormLabel';
import FormControl from '@material-ui/core/FormControl';
import MenuItem from '@material-ui/core/MenuItem';
import SpText from './SpText';
import { theme } from '../theme';

export const SpSelectMenuItem = styled(MenuItem)({
  display: 'flex ',
  flexDirection: 'column ',
  padding: '5px 10px ',
  alignItems: 'flex-start ',
  backgroundColor: 'white ',
  textAlign: 'center',
  paddingLeft: 3,
  marginTop: 1,
  marginBottom: 1,
  '&.Mui-selected': {
    backgroundColor: `${theme.colors.mainGreen.secondary} !important`,
    color: 'white !important',
    fontWeight: 600
  }
});

const CustomFormControl = styled(({ formControlWidth, m, ...other }) => <FormControl {...other} />)({
  margin: (props) => theme.spacing(props.m),
  minWidth: 120,
  maxWidth: '100%',
  flex: 1,
  width: (props) => props.formControlWidth
});

const CustomFormLabel = styled(FormLabel)({
  marginBottom: 5,
  paddingBottom: 0,
  color: theme.colors.mainGreen.secondary,
  fontWeight: 'normal',
  fontSize: 14,
  paddingTop: 8,
  textDecoration: 'none'
});

const CustomSelect = styled(Select)(({ selectvariant }) => ({
  ...selectvariant,
  minWidth: '120px',
  maxWidth: '200px',
  height: 40,
  marginTop: '0px !important',
  // marginBottom: 8,
  paddingLeft: 10,
  paddingRight: 10,
  maxHeight: '30px',
  border: '1px solid',
  borderRadius: 20,
  borderColor: theme.colors.mainGreen.main,
  color: theme.colors.mainGreen.secondary,
  backgroundColor: '#FFF !important',
  textAlign: 'left',
  '& .MuiSvgIcon-root': {
    color: theme.colors.mainGreen.secondary
  }
}));

const formControlLabelPlacementTop = {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center'
};

const formLabelLabelPlacementTop = {
  marginBottom: 0,
  paddingRight: 8
};

const variants = {
  darkGrey: {
    background: '#eceaf1'
  },
  lightGreen: {
    background: 'transparent'
  },
  white: {
    background: 'white'
  },
  noMargin: {
    margin: '0px !important',
    padding: '0px  !important',
    background: 'transparent'
  }
};

const NonEmptySelect = ({ selectVariant, children, defaultValue, classes, ...rest }) => (
  <CustomSelect
    classes={classes && classes}
    defaultValue={defaultValue}
    style={{ color: 'white !important' }}
    disableUnderline
    variant="standard"
    selectvariant={variants[selectVariant]}
    {...rest}
  >
    {children}
  </CustomSelect>
);

const EmptySelect = ({ selectVariant, children, selectPlaceholder, ...rest }) => (
  <CustomSelect
    displayEmpty
    renderValue={(value) => <SpText style={{ opacity: value && value?.length !== 0 ? 'inherit' : '0.5' }}>{selectPlaceholder}</SpText>}
    disableUnderline
    variant="standard"
    selectvariant={variants[selectVariant]}
    {...rest}
  >
    {children}
  </CustomSelect>
);

export const SpSelect = ({ label, labelPaddingTop, labelColor, labelMarginBottom, classes, children, displayLabel = true, selectVariant = 'lightGreen', formControlWidth, formControlStyle, labelPlacementLeft, selectPlaceholder = '', m = 1, ...rest }) => {
  const controlStyle = {
    ...formControlStyle,
    ...(labelPlacementLeft && formControlLabelPlacementTop)
  };

  const labelStyle = labelPlacementLeft
    ? formLabelLabelPlacementTop
    : {
        color: labelColor ? labelColor : theme.colors.mainGreen.secondary,
        paddingTop: labelPaddingTop ? labelPaddingTop : null,
        marginBottom: labelMarginBottom ? labelMarginBottom : null
      };
  return (
    <CustomFormControl
      formControlWidth={formControlWidth}
      style={controlStyle}
    >
      {displayLabel ? <CustomFormLabel style={labelStyle}>{label}</CustomFormLabel> : <></>}
      {rest.value && rest.value?.length !== 0 ? (
        <NonEmptySelect
          classes={classes && classes}
          defaultValue={rest.defaultValue}
          selectVariant={selectVariant}
          {...rest}
        >
          {children}
        </NonEmptySelect>
      ) : (
        <EmptySelect
          selectVariant={selectVariant}
          selectPlaceholder={selectPlaceholder}
          {...rest}
        >
          {children}
        </EmptySelect>
      )}
    </CustomFormControl>
  );
};
